import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Props from './CouponComponent';
import EventSummaryContainer from "../../../containers/EventSummaryContainer";
import FocusTrap from '@checkout-s/FocusTrap';

import KioskLayoutContainer from '../../kiosk/containers/KioskLayoutContainer';
import VirtualKeyboard from 'checkout/components/VirtualKeyboard';
import Translation from "../../../../shared/Translation";
import Button from 'shared/Button';

class Coupon extends Component<Props> {
    componentDidMount() {
        if (!this.props.isKiosk) {
            window.scrollTo(0,0);
        }
    }
    renderCouponContent = () => {
        if (this.props.isKioskMode) {
            return (
                <Fragment>
                    <div className="kiosk__modal__title">
                        {!!this.props.title ? this.props.title : <Translation>{'checkout__enter_promo_code'}</Translation>}
                    </div>
                    <div className="input">
                        <input className="input__control" type="text" name="couponCode"
                            placeholder="Enter code here"
                            onChange={this.couponChange}
                            value={this.props.code}
                            onFocus={this.onFocus}
                        />
                    </div>

                    <Button className="kiosk-modal__button kiosk-modal__button--primary" 
                        onClick={this.onCodeSubmit} 
                        loading={this.props.loading}
                    >
                        <Translation>{'checkout__submit'}</Translation>
                    </Button>
                    
                    <Button className="kiosk-modal__button kiosk-modal__button--secondary" onClick={this.props.onCancelCoupon}><Translation>{'checkout__cancel'}</Translation></Button>

                    { this.props.showError && <div className="message__container message__container--error">
                        <p><Translation>{'checkout__invalid_coupon_for_event'}</Translation></p>
                    </div>}
                    { this.props.showAccessCodeError && <div className="message__container message__container--error">
                        <p><Translation>{'checkout__already_used_an_access_code'}</Translation></p>
                    </div>}
                    { this.props.showWarning && <div className="message__container message__container--warning">
                        <p><Translation>{'checkout__already_applied_code'}</Translation></p>
                    </div>}
                </Fragment>
            );
        }

        return (
            <Fragment>
                <div className="tickets__content">
                    <div className="card">
                        <div className="text-center">
                            <p id='coupon-modal-title'>{!!this.props.title ? <Translation>{this.props.title}</Translation> : <Translation>{'checkout__promo_discount_or_access_code'}</Translation>}</p>
                        </div>
                      <div className="input">
                            <input className="input__control" type="text" name="couponCode"
                                placeholder="Enter code here"
                                autoFocus
                                onChange={this.couponChange}
                                value={this.props.code}
                                onFocus={this.onFocus}
                            />
                        </div>
                    </div>
                </div>
                <div className="event-inventory__footer">
                    <div className="cart__footer-actions">
                        <Button className="button--primary button--large cart__button-checkout" 
                            disabled={!this.props.code || this.props.code === "" || !!this.props.disabled}
                            onClick={this.onCodeSubmit}
                            loading={this.props.loading}
                        >
                            <Translation>{'checkout__submit'}</Translation>
                        </Button>
                        <Button className="button--clear cart__button-back" onClick={this.props.onCancelCoupon}><Translation>{'checkout__cancel'}</Translation></Button>
                    </div>
                    { this.props.showError && <div className="message__container message__container--error">
                        <p><Translation>{'checkout__invalid_coupon_for_event'}</Translation></p>
                    </div>}
                    { this.props.showAccessCodeError && <div className="message__container message__container--error">
                        <p><Translation>{'checkout__already_used_an_access_code'}</Translation></p>
                    </div>}
                    { this.props.showWarning && <div className="message__container message__container--warning">
                        <p><Translation>{'checkout__already_applied_code'}</Translation></p>
                    </div>}
                </div>
            </Fragment>
        );
    }

    onFocus = (e) => {
        if(this.props.onFocus) {
            this.props.onFocus(e, "Coupon Code");
        }
    }

    render() {

        if (!this.props.asOverlay) {
            return this.renderCouponContent();
        }

        if (this.props.isKioskMode) {
            return (
                <KioskLayoutContainer>
                    <div className="kiosk__modal">
                        <div className="kiosk__modal__content">
                            {this.renderCouponContent()}
                        </div>
                    </div>
                    <VirtualKeyboard />
                </KioskLayoutContainer>
            );
        }

        return (
            <FocusTrap fallback = {'.tickets-wrap'} >
                <dialog
                  className="tickets--as-overlay tickets-wrap"
                  aria-modal="true"
                  aria-labelledby='presale-coupon-desc'
                >
                    <div className="tickets tickets--no-animation">
                        <div className="tickets__header">
                            <div className="header__right">
                                <Button onClick={this.props.onCancelCoupon} className="button--clear button--close ticket__hide-overlay"><i className="icon-close" aria-hidden="true"></i><span className="sr-only"><Translation>{'checkout__close'}</Translation></span></Button>
                            </div>
                            <EventSummaryContainer />
                        </div>
                        {this.renderCouponContent()}
                    </div>
                </dialog>
            </FocusTrap>
        )
    }

    couponChange = (e) => {
        let code = e.target.value;
        this.props.onCodeChange(code);
    };

    onCodeSubmit = () => {
        this.props.onCodeSubmit(this.props.code);
    }
}

Coupon.propTypes = {
    code: PropTypes.string,
    onCodeChange: PropTypes.func,
    onCodeSubmit: PropTypes.func,
    onCancelCoupon: PropTypes.func,
    showError: PropTypes.bool,
    showSuccess: PropTypes.bool,
    showWarning: PropTypes.bool,
    showAccessCodeError: PropTypes.bool,
    title: PropTypes.string,
    asOverlay: PropTypes.bool,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
};

Coupon.defaultProps = {
    code: '',
    asOverlay: true,
    loading: false,
}

export default Coupon;
